jQuery(function($) {
    $( document ).ready(function() {
	
	    $( ".main_accoudian .inner_list h6" ).click(function() {
	//       $('.main_accoudian .inner_list').removeClass('active');
	    	$(this).parent().toggleClass('active');
		});

	});
});
/*$(document) .ready(function(){
$(".navmenu-link").on('click', function(){
$("details > summary").addClass("active");
});
});*/

/*
var listItems = document.querySelectorAll('.tabs > li');

for(var i = 0; i < listItems.length; i++) {
  listItems[i].className = 'grouped-content-triggers';
}

var listItems = document.querySelectorAll('.tabs-content > li');

for(var i = 0; i < listItems.length; i++) {
  listItems[i].className = 'grouped-content-triggers';
}

$(document) .ready(function(){
var myRow = 0;
$("ul.tabs-content > li.grouped-content-triggers").each(function(){
myRow = myRow + 1;
$(this).attr("id", "grouped-content-triggers" + myRow );
});
});

$(document) .ready(function(){
var myRow = 0;
$("ul.tabs > li.grouped-content-triggers").each(function(){
myRow = myRow + 1;
$(this).attr("id", "grouped-content-triggers" + myRow );
  
});
});*/

$(".options-selection__option-value.options-selection__option-value--selected span.options-selection__option-value-name").each(function(){
var str = ($(this).text());
str = $.trim(str);
if(str.indexOf("N.I.S.T") != -1){
$("p.nist-custom").css('display','block');
}else{
$("p.nist-custom").css('display','none');
}
});
$("span.options-selection__option-value-name").click(function(){
var str = ($(this).text());
str = $.trim(str);
if(str.indexOf("N.I.S.T") != -1){
$("p.nist-custom").css('display','block');
}else{
$("p.nist-custom").css('display','none');
}
});


